import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PERSON_VALID_SCHOOLS } from 'graphql/queries'
import PropTypes from 'prop-types'
import ValidSchoolsContext from './ValidSchoolsContext'
import UserContext from 'stores/UserStore'
import {
  MACKENZIE_HYBRIDA_APPLICATION_ID,
  MACKENZIE_PROPRIA_APPLICATION_ID,
  graphqlClient,
} from 'utils'
import { ROUTES } from 'utils/constants'
import LoadingContainer from 'App/components/LoadingContainer/LoadingContainer'

const filterValidSchools = (schools, roles) => {
  const validSchools = []
  schools.forEach(schoolItem => {
    const schoolsActive = []
    const schoolsRoles = roles.map(role => role.schools)

    if (schoolsRoles.length > 0) {
      schoolsRoles.forEach(schools =>
        schools.forEach(school =>
          schoolsActive.push(school.tradeName === '' ? school.legalName : school.tradeName),
        ),
      )
    }

    const validSchoolName = schoolsActive.find(
      school => school === schoolItem.tradeName || school === schoolItem.legalName,
    )
    return validSchoolName && validSchools.push(schoolItem)
  })

  return validSchools
}

const LoadValidSchools = ({ children }) => {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    getValidSchools()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getValidSchools = async () => {
    try {
      const { data } = await graphqlClient().query({
        query: PERSON_VALID_SCHOOLS,
        variables: {
          applicationId: [MACKENZIE_HYBRIDA_APPLICATION_ID, MACKENZIE_PROPRIA_APPLICATION_ID],
        },
      })

      setData(data)
    } catch (e) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }

  const userStore = useContext(UserContext)

  if (error) {
    navigate(ROUTES.PERFIL_DADOS_ESCOLARES)
  }

  if (loading) {
    return <LoadingContainer text='Carregando as escolas...' fullscreen />
  }

  const { schools, roles, externalReference } = data.person
  if (!schools || !roles) {
    navigate(ROUTES.PERFIL_DADOS_ESCOLARES)
  }

  const validSchools = filterValidSchools(schools, roles)
  userStore.setPersonSchools(schools)
  userStore.setRoles(roles)
  userStore.setExternalReference(externalReference)
  userStore.setIsUserByIntegration(data.person.byIntegration)

  return (
    <ValidSchoolsContext.Provider value={validSchools}>{children}</ValidSchoolsContext.Provider>
  )
}

LoadValidSchools.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LoadValidSchools
